/**
 * Utility functions for AdvancedStaticDynamicSelector
 */

import { 
  Database, 
  Type, 
  Calendar, 
  Hash, 
  Palette, 
  Image
} from 'lucide-react';

import { EntityType, MediaType } from '../../../core/template.schemas';
import { entityRegistry, mediaRegistry } from '../../registry';

/**
 * Get icon component for media type
 */
export const getMediaTypeIcon = (mediaType: MediaType, className: string = "w-3 h-3") => {
  switch (mediaType) {
    case 'text': return <Type className={className} />;
    case 'int': case 'float': return <Hash className={className} />;
    case 'date': return <Calendar className={className} />;
    case 'color': return <Palette className={className} />;
    case 'image': return <Image className={className} />;
    default: return <Database className={className} />;
  }
};

/**
 * Get display name for media type
 */
export const getMediaTypeDisplayName = (mediaType: MediaType): string => {
  return mediaRegistry.getDisplayName(mediaType);
};

/**
 * Get display name for entity type
 */
export const getEntityDisplayName = (entityType: EntityType): string => {
  const entity = entityRegistry.get(entityType);
  return entity?.displayName || entityType;
};

/**
 * Get default static value for media type
 */
export const getDefaultStaticValue = (mediaType: MediaType) => {
  switch (mediaType) {
    case 'date':
      return new Date().toISOString().split('T')[0]; // Default to today YYYY-MM-DD
    case 'int':
      return 0;
    case 'float':
      return 0.0;
    case 'color':
      return '#000000';
    case 'text':
      return 'Text';
    default:
      return '';
  }
};